import React from 'react';
import Resource from './../../../common/Resource'
import Panel from '../../../common/layout/Panel'


export default class extends React.Component {

    render () {
        const group_id = this.props.match.params.group_id;
        const data = {
            url: `/admin/carriers/settings/sipheaders/${group_id}/items`,
            data: {
                data: [],
                metadata: []
            },
             metadata:
                [
                    {
                        'label': 'id',
                        'source': 'ATRSIPHEADERID',
                        'type': 'primary',
                        'editable': false,
                        'visible': false
                    },
                    {
                        'label': 'Number Pattern',
                        'source': 'ATRPATTERN',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'Number pattern (empty to match all)'
                    },
                    {
                        'label': 'Header Name',
                        'source': 'ATRNAME',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'SIP header name'
                    },
                    {
                        'label': 'Header Value',
                        'source': 'ATRVALUE',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'SIP header value'
                    },
                    {
                        'label': 'Enable Rule',
                        'source': 'ATRSTATUS',
                        'type': 'checkbox',
                        'editable': true,
                        'visible': true,
                        'default' : true
                    },
                    {
                        'label' : 'Actions',
                        'type': 'action_buttons'
                    }
                ]
        }
        return (
            <Panel title = "Carrier SIP Header Rules">
                <Resource data = {data} {...this.props} addButtonValue="Add SIP Header Rule" />
            </Panel>
        )
    }
}
